import { calcCount } from '@/shared/job/insight.dto';
import { CalendarDays, Users } from 'lucide-react';
import { cn } from '@/lib/utils/utils';
import { InsightCardIcon } from './InsightCardIcon';
import { InsightMetricColumn } from './InsightMetricColumn';
import { YourCvOnlyValue } from './YourCvOnlyValue';

export function ApplicantCountCard({
  title,
  totalLabel,
  last7Label,
  yourCvOnlyLabel,
  total,
  last7Days,
  sinceLabel,
  className,
}: {
  title: string;
  totalLabel: string;
  last7Label: string;
  yourCvOnlyLabel: string;
  total: number;
  last7Days: number;
  sinceLabel?: string;
  className?: string;
}) {
  const showYourCvOnly = total === 1;

  return (
    <div
      className={cn(
        'flex h-full flex-col rounded-lg border border-gray-200 bg-white p-4',
        className
      )}
    >
      <div className="mb-4 flex items-center gap-2">
        <InsightCardIcon icon={Users} />
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>
      <div className="grid flex-1 grid-cols-2 gap-4">
        <InsightMetricColumn
          label={totalLabel}
          icon={Users}
          blurred={total === 0}
        >
          {showYourCvOnly ? (
            <YourCvOnlyValue yourCvOnlyLabel={yourCvOnlyLabel} />
          ) : (
            <p className="flex items-center gap-1 text-2xl font-medium leading-8 text-primary">
              {calcCount(total)}
            </p>
          )}
        </InsightMetricColumn>
        <InsightMetricColumn
          label={last7Label}
          icon={CalendarDays}
          blurred={last7Days === 0}
        >
          <p className="text-2xl font-bold text-primary">
            {calcCount(last7Days)}
          </p>
        </InsightMetricColumn>
      </div>
      {sinceLabel ? (
        <p className="mt-3 text-xs text-gray-400">{sinceLabel}</p>
      ) : null}
    </div>
  );
}
